"use strict";
// based on docs on pendo.io official site and convert to typescript file here.
// How to use createPendo(window, document, 'script', 'pendo')
// window.pendo.initialize({
// 	visitor: {
// 		id:              'VISITOR-UNIQUE-ID'   // Required if user is logged in, default creates anonymous ID
// 		// email:        // Recommended if using Pendo Feedback, or NPS Email
// 		// full_name:    // Recommended if using Pendo Feedback
// 		// role:         // Optional
// 		// You can add any additional visitor level key-values here,
// 		// as long as it's not one of the above reserved names.
// 	},
// 	account: {
// 		id:           'ACCOUNT-UNIQUE-ID' // Required if using Pendo Feedback, default uses the value 'ACCOUNT-UNIQUE-ID'
// 		// name:         // Optional
// 		// is_paying:    // Recommended if using Pendo Feedback
// 		// monthly_value:// Recommended if using Pendo Feedback
// 		// planLevel:    // Optional
// 		// planPrice:    // Optional
// 		// creationDate: // Optional
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPendo = void 0;
// 		// You can add any additional account level key-values here,
// 		// as long as it's not one of the above reserved names.
// 	}
// });
function createPendo(apiKey) {
    (function (p, e, n, d) {
        var _a;
        var w, x;
        var o = (p[d] = p[d] || {});
        o._q = o._q || [];
        var v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];
        for (w = 0, x = v.length; w < x; ++w)
            (function (m) {
                o[m] =
                    o[m] ||
                        function () {
                            // eslint-disable-next-line prefer-rest-params
                            o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                        };
            })(v[w]);
        var y = e.createElement(n);
        y.async = !0;
        y.src = 'https://content.pendo-analytics.modernsurvey.com/agent/static/' + apiKey + '/pendo.js';
        var z = e.getElementsByTagName(n)[0];
        (_a = z === null || z === void 0 ? void 0 : z.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(y, z);
    })(window, document, 'script', 'pendo');
}
exports.createPendo = createPendo;
